import type { Withdrawal, WithdrawalInput } from 'generated/gql';

import { mapShareSeriesToShareSeriesInput } from './ShareSeries';

export const mapWithdrawalToWithdrawalInput = (withdrawal: Withdrawal): WithdrawalInput => ({
  fromPartyId: withdrawal.from.id,
  shareSeries: mapShareSeriesToShareSeriesInput(withdrawal.shareSeries),
});
